/** @jsx h */
import { h } from 'preact'
import ProofPointStatus from '../ProofPointStatus'
import BrandingLogoFlag from '../../../../assets/images/svgs/branding-logo-flag.svg'
import DefaultIcon from '../../../../assets/images/svgs/icon-scheme-default.svg'

const ImgIcon = ({ logoUrl }) =>
  <img src={logoUrl} alt='' width='44' height='44' />

const ModalCardStickyHeader = ({ title, icon, type, headingClass, photoClasses, proofPointStatus, claimStatus }) =>
  <div class='ClaimCard-header ClaimCard-header--evidence'>
    <div
      class={photoClasses}
    >
      {icon}
    </div>
    <div class='ClaimCard-headerDetails' tabIndex='-1' data-modal-focus-target>{/* tabIndex='-1' is needed to be focused via JS, see platform.js */}
      <div class='Subheading Text--colourBoulder'>{type}</div>
      {title && <h3 class={headingClass}>{title}</h3>}
      {proofPointStatus && <ProofPointStatus status={claimStatus} />}
    </div>
  </div>

const ProofPointStickyHeader = ({ title, type, iconSvg, logoUrl, claimStatus }) => {
  let photoClasses = 'Capsule-icon '
  if (type && type.toLowerCase().includes('claim')) {
    photoClasses += 'Capsule-icon--claim'
  } else {
    photoClasses += 'Capsule-icon--schemeSolid'
  }

  const icon = iconSvg
    ? <div dangerouslySetInnerHTML={{ __html: iconSvg }} />
    : logoUrl
      ? <img src={logoUrl} alt='' width='44' height='44' />
      : <img src={DefaultIcon} alt='' width='44' height='44' />

  return <ModalCardStickyHeader title={title} icon={icon} type={type} photoClasses={photoClasses} proofPointStatus claimStatus={claimStatus} />
}

const AboutStickyHeader = ({ title, type }) =>
  <div class='ClaimCard-header--about'>
    <BrandingLogoFlag />
    <div class='ClaimCard-headerDetails' tabIndex='-1' data-modal-focus-target>{/* tabIndex='-1' is needed to be focused via JS, see platform.js */}
      <div class='Subheading Text--colourBoulder'>{type}</div>
      {title && <h3 class='BodyUI--emphasis'>{title}</h3>}
    </div>
  </div>

const OrganizationStickyHeader = ({ title, type, logoUrl }) =>
  <ModalCardStickyHeader
    title={title}
    icon={<ImgIcon logoUrl={logoUrl} />}
    type={type}
    headingClass='BodyUI--emphasis'
    photoClasses='Capsule-icon no-grayscale'
  />

const StickyHeader = ({ title, claimStatus }) =>
  <ModalCardStickyHeader
    title={title}
    headingClass='Heading--card'
    claimStatus={claimStatus}
  />

ModalCardStickyHeader.defaultProps = {
  title: null,
  icon: null,
  headingClass: 'BodyUI--emphasis',
  photoClasses: ''
}

export { ProofPointStickyHeader, OrganizationStickyHeader, StickyHeader, AboutStickyHeader }
